import { gql } from 'graphql-tag'

const imageFragment = gql`
  fragment ImageFragment on Image {
    station {
      id
      name
    }
    type
    content
    id
  }
`

export const addWeeklyInfoImage = gql`
  mutation AddWeeklyInfoImage($stationId: ID, $type: String!, $file: String!) {
    addImage(stationId: $stationId, type: $type, file: $file)
  }
`

export const fetchWeeklyInfoImages = gql`
  query FetchWeeklyInfoImages($stationId: ID!, $type: String!) {
    images(stationId: $stationId, type: $type) {
      ...ImageFragment
    }
  }
  ${imageFragment}
`

export const deleteWeeklyInfoImage = gql`
  mutation DeleteWeeklyInfoImage($imageId: ID!) {
    deleteImage(imageId: $imageId)
  }
`
